import React from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Trash } from "react-feather";
import { apiUrl } from '../../config';
const CategoryList = ({ categoryData, onEdit, onDelete }) => {
  return (
    <Table striped bordered hover responsive className="align-middle text-center">
      <thead className="table-dark">
        <tr>
          <th>S.No</th>
          <th>Code</th>
          <th>Name</th>
          <th>Category Image</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {categoryData?.map((data, index) => (
          <tr key={data.id}>
            <td>{index + 1}</td>
            <td>{data.code}</td>
            <td>{data.name}</td>
            <td>
              <div style={{ height: "40px", width: "40px", margin: "auto" }}>
                <img
                  src={apiUrl + "/" + data.imageUrl}
                  alt="Category"
                  className="img-fluid rounded"
                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                />
              </div>
            </td>
            <td>
              <Button
                variant="warning"
                size="sm"
                className="me-2"
                onClick={() => onEdit(data)}
              >
                <Edit />
              </Button>
              <Button
                variant="danger"
                size="sm"
                onClick={() => onDelete(data.id)}
              >
                <Trash />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>

  );
};

export default CategoryList;